module.exports = __webpack_public_path__ + "img/recommed-img5.ec78fe2a.jpg";